import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { LangProvider } from "@/lib/i18n";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import HomeConversational from "@/pages/HomeConversational";
import HubPage from "@/pages/HubPage";
import Chat from "@/pages/Chat";
import Cepages from "@/pages/Cepages";
import CepageDetail from "@/pages/CepageDetail";
import Appellations from "@/pages/Appellations";
import AppellationDetail from "@/pages/AppellationDetail";
import Producers from "@/pages/Producers";
import ProducerDetail from "@/pages/ProducerDetail";
import MyProducer from "@/pages/MyProducer";
import Events from "@/pages/Events";
import Carnet from "@/pages/Carnet";
import Pro from "@/pages/Pro";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ExternalAdminRedirect from "@/pages/ExternalAdminRedirect";
import Play from "@/pages/Play";
import Flashcards from "@/pages/Flashcards";
import Audrey from "@/pages/Audrey";
import Deduce from "@/pages/Deduce";
import Account from "@/pages/Account";
import Itineraries from "@/pages/Itineraries";
import Nearby from "@/pages/Nearby";
import Multiplayer from "@/pages/Multiplayer";
import MultiplayerRoom from "@/pages/MultiplayerRoom";
import ProSponsored from "@/pages/ProSponsored";
import SponsoredPlay from "@/pages/SponsoredPlay";
import Explorer from "@/pages/Explorer";
import AudreyAI from "@/pages/AudreyAI";
import Pricing from "@/pages/Pricing";
import ProDashboard from "@/pages/ProDashboard";
import ProMapBuilder from "@/pages/ProMapBuilder";
import DiscoverHub from "@/pages/DiscoverHub";
import TasteSuggestions from "@/pages/TasteSuggestions";
import TasteProfile from "@/pages/TasteProfile";
import LearnExplain from "@/pages/LearnExplain";
import LearnCoach from "@/pages/LearnCoach";
import PlayHosted from "@/pages/PlayHosted";
import PlayJoin from "@/pages/PlayJoin";
import PlayRewards from "@/pages/PlayRewards";
import Guide from "@/pages/Guide";
import BillingSuccess from "@/pages/BillingSuccess";
import Billing from "@/pages/Billing";
import CheckoutComplete from "@/pages/CheckoutComplete";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Legal from "@/pages/Legal";
import LearnHome from "@/pages/LearnHome";
import AcademyHome from "@/pages/AcademyHome";
import CourseDetail from "@/pages/CourseDetail";
import JourneyRunner from "@/pages/JourneyRunner";
import CourseCertificate from "@/pages/CourseCertificate";
import CertificateVerify from "@/pages/CertificateVerify";
import Passport from "@/pages/Passport";
import ReviewsDashboard from "@/pages/ReviewsDashboard";
import PlayHome from "@/pages/PlayHome";
import MaestroHome from "@/pages/MaestroHome";
import MaestroBuilder from "@/pages/MaestroBuilder";
import MaestroHost from "@/pages/MaestroHost";
import MaestroPlayer from "@/pages/MaestroPlayer";
import MaestroRecap from "@/pages/MaestroRecap";
import Microlearning from "@/pages/Microlearning";
import MicrolearningReview from "@/pages/MicrolearningReview";
import Dashboard from "@/pages/Dashboard";
import Shop from "@/pages/Shop";
import ShopProduct from "@/pages/ShopProduct";
import ShopCart from "@/pages/ShopCart";
import ShopCheckout from "@/pages/ShopCheckout";
import ShopOrderSuccess from "@/pages/ShopOrderSuccess";
// ── geoVINUM Experience ──
import ExperienceHome from "@/pages/experience/ExperienceHome";
import ExperienceEventPublic from "@/pages/experience/ExperienceEventPublic";
import ExperienceCheckoutSuccess from "@/pages/experience/ExperienceCheckoutSuccess";
import ExperienceAddonSuccess from "@/pages/experience/ExperienceAddonSuccess";
import ExperienceMy from "@/pages/experience/ExperienceMy";
import ExperienceTasting from "@/pages/experience/ExperienceTasting";
import ExperienceQuiz from "@/pages/experience/ExperienceQuiz";
import StaffScanner from "@/pages/experience/StaffScanner";
import ProExperienceHome from "@/pages/experience/ProExperienceHome";
import ProOrgDetail from "@/pages/experience/ProOrgDetail";
import ProEventDetail from "@/pages/experience/ProEventDetail";
import AdminExperience from "@/pages/experience/AdminExperience";
import { CartProvider } from "@/lib/cart";
import { SRSCountProvider } from "@/lib/srsCount";
import UpgradeNudgeListener from "@/components/UpgradeNudgeListener";
import PwaInstallPrompt from "@/components/PwaInstallPrompt";
import PwaUpdatePrompt from "@/components/PwaUpdatePrompt";
import CookieBanner from "@/components/CookieBanner";
import AgeGate from "@/components/AgeGate";
import PushAutoPrompt from "@/components/PushAutoPrompt";
import { Navigate } from "react-router-dom";
import { Toaster } from "sonner";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LangProvider>
          <AuthProvider>
            <CartProvider>
              <SRSCountProvider>
            <Toaster theme="light" richColors position="bottom-right" />
            <AgeGate />
            <CookieBanner />
            <PushAutoPrompt />
            <Layout>
              <Routes>
                <Route path="/" element={<HomeConversational />} />
                <Route path="/hub/:pillar" element={<HubPage />} />
                <Route path="/home-classic" element={<Home />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/cepages" element={<Cepages />} />
                <Route path="/cepages/:slug" element={<CepageDetail />} />
                <Route path="/identify" element={<Navigate to="/explorer" replace />} />
                <Route path="/explorer" element={<Explorer />} />
                <Route path="/audrey-ai" element={<AudreyAI />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/pro/dashboard" element={<ProDashboard />} />
                <Route path="/pro/map-builder" element={<ProMapBuilder />} />
                <Route path="/appellations" element={<Appellations />} />
                <Route path="/appellations/:slug" element={<AppellationDetail />} />
                <Route path="/producers" element={<Producers />} />
                <Route path="/producers/mine" element={<MyProducer />} />
                <Route path="/producers/new" element={<MyProducer />} />
                <Route path="/producers/:slug" element={<ProducerDetail />} />
                <Route path="/events" element={<Events />} />
                <Route path="/carnet" element={<Carnet />} />
                <Route path="/pro" element={<Pro />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                {/* Admin panel lives on https://geovinum.io/admin — redirect internal routes */}
                <Route path="/admin" element={<ExternalAdminRedirect />} />
                <Route path="/admin/*" element={<ExternalAdminRedirect />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/learn" element={<LearnHome />} />
                <Route path="/courses" element={<AcademyHome />} />
                <Route path="/courses/:slug" element={<JourneyRunner />} />
                <Route path="/courses/:slug/classic" element={<CourseDetail />} />
                <Route path="/courses/:slug/certificate/:certId" element={<CourseCertificate />} />
                <Route path="/verify/:certId" element={<CertificateVerify />} />
                <Route path="/passport" element={<Passport />} />
                <Route path="/revisions" element={<ReviewsDashboard />} />
                <Route path="/microlearning" element={<Microlearning />} />
                <Route path="/microlearning/review" element={<MicrolearningReview />} />
                <Route path="/play" element={<PlayHome />} />
                <Route path="/play/solo" element={<Play />} />
                <Route path="/flashcards" element={<Flashcards />} />
                <Route path="/audrey" element={<Audrey />} />
                <Route path="/deduce" element={<Deduce />} />
                <Route path="/account" element={<Account />} />
                <Route path="/itineraries" element={<Itineraries />} />
                <Route path="/nearby" element={<Nearby />} />
                <Route path="/multiplayer" element={<Multiplayer />} />
                <Route path="/multiplayer/:mode/:roomId" element={<MultiplayerRoom />} />
                <Route path="/pro/sponsored" element={<ProSponsored />} />
                <Route path="/games/sponsored/:gameId" element={<SponsoredPlay />} />
                <Route path="/discover" element={<DiscoverHub />} />
                <Route path="/taste/suggestions" element={<TasteSuggestions />} />
                <Route path="/taste/profile" element={<TasteProfile />} />
                <Route path="/learn/explain" element={<LearnExplain />} />
                <Route path="/learn/coach" element={<LearnCoach />} />
                <Route path="/play/hosted" element={<PlayHosted />} />
                <Route path="/play/join" element={<PlayJoin />} />
                <Route path="/play/maestro" element={<MaestroHome />} />
                <Route path="/play/maestro/new" element={<MaestroBuilder />} />
                <Route path="/play/maestro/edit/:id" element={<MaestroBuilder />} />
                <Route path="/play/maestro/host/:code" element={<MaestroHost />} />
                <Route path="/play/maestro/recap/:code" element={<MaestroRecap />} />
                <Route path="/play/maestro/play" element={<MaestroPlayer />} />
                <Route path="/play/rewards" element={<PlayRewards />} />
                <Route path="/guide" element={<Guide />} />
                <Route path="/billing" element={<Billing />} />
                <Route path="/billing/success" element={<BillingSuccess />} />
                <Route path="/checkout/complete" element={<CheckoutComplete />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/product/:id" element={<ShopProduct />} />
                <Route path="/shop/cart" element={<ShopCart />} />
                <Route path="/shop/checkout" element={<ShopCheckout />} />
                <Route path="/shop/order" element={<ShopOrderSuccess />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/legal/:kind" element={<Legal />} />
                {/* geoVINUM Experience — B2B event platform */}
                <Route path="/experience" element={<ExperienceHome />} />
                <Route path="/experience/event/:slug" element={<ExperienceEventPublic />} />
                <Route path="/experience/success" element={<ExperienceCheckoutSuccess />} />
                <Route path="/experience/addons/success" element={<ExperienceAddonSuccess />} />
                <Route path="/experience/cancel" element={<ExperienceHome />} />
                <Route path="/experience/my" element={<ExperienceMy />} />
                <Route path="/experience/tasting/:wineId" element={<ExperienceTasting />} />
                <Route path="/experience/quiz/:wineId" element={<ExperienceQuiz />} />
                <Route path="/experience/staff" element={<StaffScanner />} />
                <Route path="/pro/experience" element={<ProExperienceHome />} />
                <Route path="/pro/experience/orgs/:orgId" element={<ProOrgDetail />} />
                <Route path="/pro/experience/events/:eventId" element={<ProEventDetail />} />
                <Route path="/admin/experience" element={<AdminExperience />} />
              </Routes>
              <UpgradeNudgeListener />
              <PwaInstallPrompt />
              <PwaUpdatePrompt />
            </Layout>
              </SRSCountProvider>
            </CartProvider>
          </AuthProvider>
        </LangProvider>
      </BrowserRouter>
    </div>
  );
}
